import { Pipe, PipeTransform, NgZone, ChangeDetectorRef } from '@angular/core';
import { IsEqualStrings } from '@apply4u/shared/helpers/common/string-helpers';
import { IsNotNull } from '@apply4u/shared/helpers/common/type-safe-helpers';

@Pipe({
    name: 'timeAgo',
    standalone:true
})
export class TimeagoPipe implements PipeTransform {

    constructor(private ngZone: NgZone, private changeDetectorRef: ChangeDetectorRef) {

    }

    timer: any = null;

    transform(value: any, isAgoRequired: boolean = false): any {

        if (IsNotNull(value) && !this.IsMinimumDateTimeValue(value)) {
            let d = new Date(value);
            let now = new Date();
            let seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000));
            let timeToUpdate = (Number.isNaN(seconds)) ? 1000 : this.getSecondsUntilUpdate(seconds) * 1000;

            this.timer = this.ngZone.runOutsideAngular(() => {
                if (typeof window !== 'undefined') {
                    return window.setTimeout(() => {
                        this.ngZone.run(() => this.changeDetectorRef.markForCheck());
                    }, timeToUpdate);
                }
                return null;
            });


            let minutes = Math.round(Math.abs(seconds / 60));
            let hours = Math.round(Math.abs(minutes / 60));
            let days = Math.round(Math.abs(hours / 24));
            let months = Math.round(Math.abs(days / 30.416));
            let years = Math.round(Math.abs(days / 365));

            if (Number.isNaN(seconds)) {
                return '';
            }
            else if (seconds <= 45) {
                return 'a few seconds' + (isAgoRequired ? ' ago' : '');
            }
            else if (seconds <= 90) {
                return 'a minute ago';
            }
            else if (minutes <= 45) {
                return minutes + ' minutes' + (isAgoRequired ? ' ago' : '');
            }
            else if (minutes <= 90) {
                return 'an hour' + (isAgoRequired ? ' ago' : '');
            }
            else if (hours <= 22) {
                return hours + ' hours' + (isAgoRequired ? ' ago' : '');
            }
            else if (hours <= 36) {
                return 'a day' + (isAgoRequired ? ' ago' : '');
            }
            else if (days <= 25) {
                return days + ' days' + (isAgoRequired ? ' ago' : '');
            }
            else if (days <= 45) {
                return 'a month' + (isAgoRequired ? ' ago' : '');
            }
            else if (days <= 345) {
                return months + ' months' + (isAgoRequired ? ' ago' : '');
            }
            // else if (days <= 545) {
            //     return 'a year';
            // }
            else {
                // (days > 545)
                // return years + ' years' + (isAgoRequired ? ' ago' : '');
                return ' over a year' + (isAgoRequired ? ' ago' : '');
            }
        } else {
            return null;
        }
    }

    getSecondsUntilUpdate(seconds) {
        let min = 60;
        let hr = min * 60;
        let day = hr * 24;
        if (seconds < min) {
            return 2;
        }
        else if (seconds < hr) {
            return 30;
        }
        else if (seconds < day) {
            return 300;
        }
        else {
            return 3600;
        }
    }

    removeTimer() {
        if (this.timer) {
            window.clearTimeout(this.timer);
            this.timer = null;
        }
    }

    IsMinimumDateTimeValue(eta: Date): Boolean {
        const day = new Date(eta).getDate();
        const month = new Date(eta).getMonth();
        const year = new Date(eta).getFullYear();
        const userDate = `${day}/${month}/${year}`;

        return IsEqualStrings(userDate, "1/1/0001");
    }

    ngOnDestroy() {
        this.removeTimer();
    }

}
